module.exports = __webpack_public_path__ + "img/dec3.62a00160.jpg";